import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DriverService } from '../../services/driver/driver.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-driver-licence-form',
  templateUrl: './driver-licence-form.component.html',
  styleUrls: ['./driver-licence-form.component.scss']
})
export class DriverLicenceFormComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Output() modifiedValueOutput = new EventEmitter<any>();
  @Output() onFileSelect = new EventEmitter<any>();
  @Output() onFileDelete = new EventEmitter<any>();

  expiryDays: any;
  licenseNo: any;
  licenseType: any;
  issueDate: any;
  expireDate: any;
  issuingAuthority: any;
  listOfFile: any[];
  listOfDetails
  constructor(private driverService: DriverService, private translate: TranslateService) {

  }
  ngOnInit() {
    this.intializeform();
    this.getLicenceTypeList();
  }
  intializeform() {
    this.licenseNo = {
      lable: this.translate.instant("DRIVERLICENSE.LicenseNo"),
      dataField: 'LicenseNo',
      // type: 'number',
      formControlName: 'LicenseNo',
      placeholder: this.translate.instant("DRIVERLICENSE.EnterLicenseNo")
    };
    this.licenseType = {
      lable: this.translate.instant("DRIVERLICENSE.LicenseType"),
      dataField: 'LicenseType',
      formControlName: 'LicenseType',
      placeholder: this.translate.instant("DRIVERLICENSE.SelectLicenseType"),
      isValueBind: true,
    };
    this.issueDate = {
      lable: this.translate.instant("DRIVERLICENSE.DateofIssue"),
      dataField: 'IssueDate',
      formControlName: 'IssueDate',
      placeholder: this.translate.instant("DRIVERLICENSE.SelectIssueDate")
    };
    this.expireDate = {
      lable: this.translate.instant("DRIVERLICENSE.DateofExpiry"),
      dataField: 'ExpiryDate',
      formControlName: 'ExpiryDate',
      placeholder: this.translate.instant("DRIVERLICENSE.SelectDateofExpiry"),
    };
    this.issuingAuthority = {
      lable: this.translate.instant("DRIVERLICENSE.IssuingAuthority"),
      dataField: 'AuthorityName',
      formControlName: 'AuthorityName',
      placeholder: this.translate.instant("DRIVERLICENSE.EnterIssuingAuthority"),
    };
  }


  ngOnChanges() {
    this.listOfFile = [];
    if (this.data.FileName) {
      const fileName = this.data.FileName.split("_")[1] + this.data.FileExtension;
      const path = this.data.LicensePhotoPath
      this.listOfFile.push({ name: fileName, path: path });
    }
  }
  getChangedValue(value, dataFeild) {
    this.modifiedValueOutput.emit({ value, dataFeild })
    if (dataFeild == 'ExpiryDate') {
      this.data.licenceValidDays = this.getLicenceValidation(value);
    }
  }

  getLicenceValidation(value): any {
    const days = this.driverService.calculateDaysBetweenDates(new Date(), value)
    const licenceValidDays = days;
    return licenceValidDays;
  }

  onFileSelectFn(selectedFile) {
    this.onFileSelect.emit(selectedFile);
  }

  onFileDeleteFn(selectedFile) {
    this.onFileDelete.emit(selectedFile);
  }
  getLicenceTypeList() {
    this.driverService.getLicenceTypeList()
      .then((data) => {
        this.licenseType = { ...this.licenseType, dropdownList: data };
        console.log(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }

}
